<template>
  <div class="dcw-card">
    <div v-if="dashboard" class="d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div class="dcw-info">
        <div class="dcw-name">{{ name }}</div>
        <span class="dcw-widget-count">{{ $t('Assistant.Widget.Dashboard.WidgetCount', { count: widgetCount }) }}</span>
      </div>
      <router-link :to="openLink" class="btn btn-sm btn-outline-primary mb-0">
        {{ $t('Assistant.Widget.Dashboard.Open') }}
      </router-link>
    </div>
    <div v-else class="dcw-empty">{{ $t('Assistant.Widget.Unsupported', { type: 'dashboard' }) }}</div>
  </div>
</template>

<script>
// Renders the dashboard object returned by create/update/get_dashboard as a small card
// (name + widget count + link), mirroring BroadcastCardWidget/AutomationCardWidget. Dashboards
// have no status concept, so this is simpler than those two.
export default {
  name: 'DashboardCardWidget',
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    dashboard() {
      return this.data?.dashboard ?? null
    },
    name() {
      return this.dashboard?.name || this.$t('Assistant.Widget.Dashboard.Untitled')
    },
    widgetCount() {
      return Array.isArray(this.dashboard?.layout) ? this.dashboard.layout.length : 0
    },
    openLink() {
      return { name: 'DashboardView', params: { id: this.dashboard.uuid } }
    },
  },
}
</script>

<style scoped>
.dcw-card {
  width: 100%; padding: 12px 16px; border: 1px solid var(--ui-border); border-radius: var(--radius-lg);
  background: var(--ui-bg-card);
}
.dcw-info { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.dcw-name { font: 600 13px 'Open Sans', sans-serif; color: var(--ui-text-1); }
.dcw-widget-count { font: 500 12px 'Open Sans', sans-serif; color: var(--ui-text-3); }
.dcw-empty {
  display: flex; align-items: center; justify-content: center; min-height: 40px;
  font: 500 12px 'Open Sans', sans-serif; color: var(--ui-text-3);
}
</style>
